import React, { useEffect, useState } from 'react'
import { Combobox } from 'react-widgets'
import DatePicker from '../Layout/DatePicker'

const FilterBar = ({
  onHandleFilter
}) => {
  const [show, setShow] = useState(false)

  const [filterData, setFilterData] = useState({
    StartDate: new Date(new Date().getFullYear(), 0, 1),
    EndDate: new Date(),
    PVStartDate: new Date(new Date().getFullYear(), 0, 1),
    PVEndDate: new Date(),
    LiveListBy: 'Branch',
  })

  // LIST BY
  const listBy = [
    {value: 'Branch', name: 'Branch'},
    {value: 'Group', name: 'Group'}
  ]

  const handleSelectSalesStartDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      StartDate: date,
    }));
  }

  const handleSelectSalesEndDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      EndDate: date,
    }));
  }

  const handleSelectPVStartDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      PVStartDate: date,
    }));
  }

  const handleSelectPVEndDate = (date) => {
    setFilterData((prev) => ({
      ...prev,
      PVEndDate: date,
    }));
  }

  const handleSelectListedBy = (selected) => {
    setFilterData((prev) => ({
      ...prev,
      LiveListBy: selected.value,
    }));
  };

  const handleFilter = () => {
    setShow(false)
    onHandleFilter(filterData)
  }

  useEffect(() => {
    handleFilter()
  }, [])

  return (
    <div className='relative w-full h-[50px]'>
      <div className='absolute w-full'>
        <div className={ 'filterbar ' + (show ? '' : 'hide') }>
          <button onClick={ () => setShow(!show) } className='btn-show'>
            <div className='btn'>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75" />
              </svg>
            </div>
          </button>
          
          <div className='filterbar__categories'>
            <div className='filterbar__category-wrapper md:mt-0 mt-1'>
              <div className='filterbar__category'>
                <label>Sales Start Date</label>

                <DatePicker
                  selectedDate={ filterData.StartDate }
                  onSelect={ handleSelectSalesStartDate }
                />
              </div>

              <div className='filterbar__category'>
                <label>Sales End Date</label>

                <DatePicker
                  selectedDate={ filterData.EndDate }
                  onSelect={ handleSelectSalesEndDate }
                  right={ true }
                />
              </div>
            </div>

            <div className='filterbar__category-wrapper'>
              <div className='filterbar__category'>
                <label>PV Start Date</label>

                <DatePicker
                  selectedDate={ filterData.PVStartDate }
                  onSelect={ handleSelectPVStartDate }
                />
              </div>

              <div className='filterbar__category'>
                <label>PV End Date</label>

                <DatePicker
                  selectedDate={ filterData.PVEndDate }
                  onSelect={ handleSelectPVEndDate }
                  right={ true }
                />
              </div>
            </div>
            
            <div className='filterbar__category'>
              <label>List By</label>

              <Combobox
                className="list-box"
                data={ listBy }
                defaultValue={ filterData.LiveListBy }
                dataKey='value'
                textField='name'
                onSelect={ handleSelectListedBy }
                filter='contains'
              />
            </div>
          </div>

          <div className='filterbar__btn'>
            <button
              onClick={ handleFilter }
              type="button"
              className='btn-search'
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FilterBar